import "./LosAngelesRefrigeratedTrailerRental.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrailerLineup from "./sections/TrailerLineup";
import PotentialApplications from "./sections/PotentialApplications";
import DeliveryPlacementSoCal from "./sections/DeliveryPlacementSoCal";
import ServiceAreaMap from "./sections/ServiceAreaMap";
import AngelesFaq from "./sections/AngelesFaq";
import QuoteRequestCta from "./sections/QuoteRequestCta";
import Footer from "@/reusable_sections/Footer";
export default function LosAngelesRefrigeratedTrailerRentalPage() {
  return <div>
      <Header />
      <Hero />
      <TrailerLineup />
      <PotentialApplications />
      <DeliveryPlacementSoCal />
      <ServiceAreaMap />
      <AngelesFaq />
      <QuoteRequestCta />
      <Footer />
    </div>;
}